
export default function DifferentiatorSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-light text-gray-900 mb-4">
            Why DHB Group Leads Cross-Border OOH
          </h2>
          <p className="text-base sm:text-lg text-gray-600 font-light max-w-3xl mx-auto">
            Unmatched expertise in navigating GCC and Asian outdoor advertising landscapes
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-12">
          {/* Cross-Border Expertise */}
          <div className="text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-global-line text-2xl sm:text-3xl text-blue-600"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-medium text-gray-900 mb-3 sm:mb-4">Cross-Border Expertise</h3>
            <div className="space-y-2 sm:space-y-3 text-gray-600 font-light text-sm sm:text-base">
              <p>• Dual market mastery: GCC cultural nuances + Asian consumer behavior</p>
              <p>• Regulatory navigation across 12+ countries</p>
              <p>• Currency hedging and multi-market budget optimization</p>
              <p>• Time zone coordination for synchronized launches</p>
            </div>
          </div>

          {/* Premium Location Access */}
          <div className="text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-map-pin-line text-2xl sm:text-3xl text-blue-600"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-medium text-gray-900 mb-3 sm:mb-4">Premium Location Access</h3>
            <div className="space-y-2 sm:space-y-3 text-gray-600 font-light text-sm sm:text-base">
              <p>• Exclusive partnerships with Dubai, Riyadh, Seoul airports</p>
              <p>• Prime highway billboard inventory (King Fahd Road, Gangnam)</p>
              <p>• Luxury mall atriums (Dubai Mall, Lotte World Tower)</p>
              <p>• Government relations for permit acceleration</p>
            </div>
          </div>

          {/* Advanced Analytics */}
          <div className="text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-line-chart-line text-2xl sm:text-3xl text-blue-600"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-medium text-gray-900 mb-3 sm:mb-4">Advanced Analytics</h3>
            <div className="space-y-2 sm:space-y-3 text-gray-600 font-light text-sm sm:text-base">
              <p>• Real-time foot traffic measurement via AI cameras</p>
              <p>• Demographic profiling through mobile data partnerships</p>
              <p>• Cross-platform attribution (OOH → digital conversions)</p>
              <p>• Predictive modeling for optimal placement timing</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-12 sm:mt-16 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8 sm:p-12 text-center">
          <h3 className="text-xl sm:text-2xl font-light text-gray-900 mb-3 sm:mb-4">
            Ready to Launch Your Cross-Border Campaign?
          </h3>
          <p className="text-base sm:text-lg text-gray-600 font-light mb-6 sm:mb-8 max-w-2xl mx-auto">
            Get a customized proposal for your GCC-Asia expansion. Free consultation includes market analysis, location recommendations, and budget optimization.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={scrollToContact}
              className="bg-blue-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-blue-700 transition-colors font-medium text-base sm:text-lg whitespace-nowrap cursor-pointer"
            >
              Get Campaign Proposal
            </button>
            <button 
              onClick={scrollToContact}
              className="border border-blue-600 text-blue-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-blue-50 transition-colors font-medium text-base sm:text-lg whitespace-nowrap cursor-pointer"
            >
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
